import {API_URL, apiDelete} from '../api'

export const deletePromotion = async (id: string) => {
    return await apiDelete(API_URL, `admin/promotion/${id}`)
}
